const num = {
    0: "०",
    1: "१",
    2: "२",
    3: "३",
    4: "४",
    5: "५",
    6: "६",
    7: "७",
    8: "८",
    9: "९",
}

export const number = (strNum) => {
    const language = window.language

    if (strNum !== 0 && !strNum) {
        return strNum
    }
    if (language === "np") {
        let arrNumNe = strNum
            .toString()
            .split("")
            .map((ch) => {
                // if (ch === "." || ch === ",") {
                //   return ch;
                // }
                if (!Object.keys(num).includes(ch)) {
                    return ch
                }
                return num[Number(ch)]
            })
        return arrNumNe.join("")
    } else {
        return strNum
    }
}

export const neNumberToEn = (strNum) => {
    const language = window.language

    if (strNum !== 0 && !strNum) {
        return strNum
    }
    if (language === "en") {
        let arrNum = strNum
            .toString()
            .split("")
            .map((ch) => {
                const value = Object.values(num).find((val) => val === ch);
                if (value) {
                    return Object.keys(num).find((key) => num[key] === value);
                }
                return ch;
            })
        return arrNum.join("")
    } else {
        return strNum
    }
}

export const currency = (num) => {
    const language = window.language

    const locale = language === "np" ? "IN" : "US"
    const formattedNum = Number(num).toLocaleString("en-" + locale)
    return number(formattedNum)
}

export const formattedCurrency = (num) => {
    const language = window.language
    if (num !== 0 && (Number(num) === "NaN" || !num)) return num
    return number(language === "np" ? nepaliNumberFormat(num) : englishNumberFormat(num))
}

const englishNumberFormat = (labelValue) => {
    if (Math.abs(Number(labelValue)) >= 1.0e9) {
        return Number((Math.abs(Number(labelValue)) / 1.0e9).toFixed(0)) + "Bn"
    } else if (Math.abs(Number(labelValue)) >= 1.0e6) {
        return Number((Math.abs(Number(labelValue)) / 1.0e6).toFixed(0)) + "M"
    } else if (Math.abs(Number(labelValue)) >= 1.0e3) {
        return Number((Math.abs(Number(labelValue)) / 1.0e3).toFixed(0)) + "K"
    } else {
        let number = Number(Math.abs(Number(labelValue)))
            .toFixed(2)
            .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
            .replace(".00", "")
        number = number.split(".")[0]
        return number
    }
}

const nepaliNumberFormat = (labelValue) => {
    if (Math.abs(Number(labelValue)) >= 1.0e9) {
        return Number((Math.abs(Number(labelValue)) / 1.0e9).toFixed(1)) + " अर्ब"
    } else if (Math.abs(Number(labelValue)) >= 1.0e7) {
        return Number((Math.abs(Number(labelValue)) / 1.0e7).toFixed(1)) + " करोड"
    } else if (Math.abs(Number(labelValue)) >= 1.0e5) {
        console.log(labelValue, Number((Math.abs(Number(labelValue)) / 1.0e5).toFixed(1)))
        return Number((Math.abs(Number(labelValue)) / 1.0e5).toFixed(1)) + " लाख"
    } else if (Math.abs(Number(labelValue)) >= 1.0e3) {
        return Number((Math.abs(Number(labelValue)) / 1.0e3).toFixed(1)) + " हजार"
    } else {
        let number = Number(Math.abs(Number(labelValue)))
            .toFixed(2)
            .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
            .replace(".00", "")
        number = number.split(".")[0]
        return number
    }
}




// WEBPACK FOOTER //
// ./src/localization/number.js